import * as Tooltip from "@radix-ui/react-tooltip"
import { cn } from "../../../lib/utils"

export function TooltipProvider({ children }) {
  return <Tooltip.Provider delayDuration={300}>{children}</Tooltip.Provider>
}

export default function AppTooltip({ content, children, side = "top" }) {
  return (
    <Tooltip.Provider delayDuration={300}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side={side}
            sideOffset={4}
            className={cn(
              "z-50 max-w-[220px] rounded px-2 py-1",
              "bg-[#424C63] text-white text-[12px] leading-snug",
              "shadow-[0_2px_8px_rgba(0,0,0,0.15)]",
              "animate-tooltip-fade-in",
            )}
          >
            {content}
            <Tooltip.Arrow className="fill-[#424C63]" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  )
}
